// Service Dependencies
import { Injectable } from '@angular/core';
import {
    HttpClient,
    HttpHeaders,
    HttpEvent,
    HttpParams,
    HttpRequest,
    HttpErrorResponse,
} from '@angular/common/http';

// App Config data
import { AppSettings } from '../../../app.config';

// Rxjs
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable()
export class ManagementNotificationsService {
    apiUrl: string;

    constructor(private http: HttpClient) {
        this.apiUrl = AppSettings.API_PROD_ENDPOINT;
    }

    getUsers(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const requesttUrl = this.apiUrl + `db-users`;

        return this.http.get(requesttUrl, { headers }).pipe(
            map((res: Response) => res),
            catchError((err) => {
                console.error(
                    'Error: ' +
                    err.error.code +
                    ': ' +
                    err.error.message +
                    ' (' +
                    err.status +
                    ': ' +
                    err.statusText +
                    ')'
                );
                return err;
            })
        );
    }

    getUsersPaginated(
        params: any = { page: 1, take: 10, order: 'ASC' }
    ): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        let httpParams = new HttpParams();
        Object.keys(params).forEach((key) => {
            httpParams = httpParams.set(key, params[key]);
        });
        const requesttUrl = this.apiUrl + `db-users/paginated`;
        return this.http.get(requesttUrl, { headers, params: httpParams }).pipe(
            map((res: Response) => res),
            catchError((err) => {
                console.error(
                    'Error: ' +
                    err.error.code +
                    ': ' +
                    err.error.message +
                    ' (' +
                    err.status +
                    ': ' +
                    err.statusText +
                    ')'
                );
                return err;
            })
        );
    }



    getNotificatiosGracePeriods(): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');


        const requestUrl = `${this.apiUrl}db-notifications-grace-periods`;

        return this.http.get(requestUrl, { headers }).pipe(
            map(response => {
                return response as any[];
            }),
            catchError(error => {
                console.error('Error fetching team members:', error);
                return throwError(error);
            })
        );
    }
    createNotificatiosGracePeriods(dates: any): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');


        const requestUrl = `${this.apiUrl}db-notifications-grace-periods/create_dates`;

        return this.http.post(requestUrl, dates, { headers }).pipe(
            map(response => {
                return response as any[];
            }),
            catchError(error => {
                console.error('Error creando fechas :', error);
                return error;
            })
        );
    }
    deleteNotificatiosGracePeriods(id: number): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');


        const requestUrl = `${this.apiUrl}db-notifications-grace-periods/${id}`;

        return this.http.delete(requestUrl, { headers }).pipe(
            map(response => {
                return response as any[];
            }),
            catchError(error => {
                console.error('Error fetching team members:', error);
                return throwError(error);
            })
        );
    }


}